export enum NonBFIExperienceActionType {
    AddNonBfi = 0,
    ModifyNonBfi = 1,
    DeleteNonBfi = 2,
    AuditHistory = 3,
}
